import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppRouter } from './router';
import { Toaster } from './components/ui/Toast';
import { ConfirmDialogHost } from './components/ui/ConfirmDialog';
import { ThemeApplier } from './store/theme';
import { I18nSync } from './store/i18n';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

// SPA basename — auto-detect from where the page is actually served so the
// same build works at `/`, `/v8/`, or any sub-path. Vite's `base: './'`
// already makes asset URLs relative; this just tells React Router how much
// of the URL to ignore.
function detectBasename(): string {
  if (!import.meta.env.PROD) return '/';
  // The directory containing index.html is the basename. Strip the file part.
  const path = window.location.pathname.replace(/\/[^/]*$/, '/');
  return path === '/' ? '/' : path.replace(/\/$/, '');
}
const basename = detectBasename();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={basename}>
        <ThemeApplier />
        <I18nSync />
        <AppRouter />
        <Toaster />
        <ConfirmDialogHost />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
);
